import { analytics, events } from 'services/analytics';
import useSubscription from 'services/hooks/subscription/useSubscription';
import useAuthStore from 'services/hooks/auth/useAuthStore';

export const useAnalyticsTracking = (): {
  trackUserStatus: () => void;
} => {
  const { authStore } = useAuthStore();
  const { isLoggedIn } = authStore;

  const { isSubscriptionActive } = useSubscription();

  const trackUserStatus = () => {
    analytics.track(events.userStatus(isLoggedIn, isSubscriptionActive));
  };

  return {
    trackUserStatus,
  };
};
